import React from "react";
import { collageImages } from "../../data/story";
import { freedomMeanings } from "../../data/program";
export function Freedom() {
  return <section className="bg-paper text-ink" data-id="element-51" data-mp="xoyr2iyh2cpv">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-6 md:py-28" data-id="element-52" data-mp="12na2gy4f0va7">
        <h2 className="max-w-4xl font-display text-4xl font-black uppercase leading-none md:text-6xl" data-id="element-53" data-mp="12lyz2zevtpjm">
          Y si yo pude empezar vendiendo globos…
        </h2>

        <ol className="mt-12 grid grid-cols-2 gap-3 md:grid-cols-4" data-id="element-54" data-mp="1cd3d9wwqh6de">
          {collageImages.map((img, i) => <li key={img.label} className={i % 2 === 1 ? "md:mt-10" : ""} data-id="element-55" data-mp="1hav6cu946yj6" data-mpi={i}>
              <img src={img.src} alt={img.alt} className="aspect-[3/4] w-full rounded-xl object-cover" data-id="element-56" data-mp="1lfl12fs1e72i" />
              <p className="mt-3 font-display text-sm font-extrabold uppercase" data-id="element-57" data-mp="1qc2z6wsv375v">
                <span className="text-ink/40" data-id="element-58" data-mp="3n6pr57ebmzkq">{i + 1} · </span>
                {img.label}
              </p>
            </li>)}
        </ol>

        <div className="mt-14 grid gap-12 md:mt-20 md:grid-cols-2 md:gap-20" data-id="element-59" data-mp="3s6kgh6ig7h3o">
          <div className="space-y-3 text-lg leading-relaxed text-ink/75" data-id="element-60" data-mp="1cohai9me3qyo">
            <p data-id="element-61" data-mp="17veocmjxzjsi">No fue inmediato. No fue fácil. No tuve todas las respuestas.</p>
            <p data-id="element-62" data-mp="13ucmdxyn4tmu">Pero seguí. Aprendí. Me equivoqué. Volví a empezar.</p>
            <p data-id="element-63" data-mp="yvroi56v2m1k">Y terminé construyendo algo que me dio algo que durante mucho tiempo estaba buscando:</p>
            <p className="pt-2 font-display text-5xl font-black uppercase text-ink md:text-7xl" data-id="element-64" data-mp="1vm1zdgp5mpja">Libertad.</p>
          </div>
          <div data-id="element-65" data-mp="1rk71km6fmua9">
            <h3 className="font-display text-3xl font-black uppercase leading-tight" data-id="element-66" data-mp="1rli1uc0o5jwm">Ahora quiero ayudarte a construir la tuya.</h3>
            <p className="mt-4 text-lg text-ink/75" data-id="element-67" data-mp="1mngma12gc2pw">No quiero que seas como yo. Quiero que construyas tu propio camino.</p>
            <p className="mt-3 text-lg text-ink/75" data-id="element-68" data-mp="b675jmapjosa">Porque la libertad no se ve igual para todos.</p>
            <ul className="mt-6 space-y-2 border-l-2 border-ink pl-5 text-lg" data-id="element-69" data-mp="673yxxf2xai7">
              {freedomMeanings.map(m => <li key={m} data-id="element-70" data-mp="7o1bmegc7k3x">{m}</li>)}
            </ul>
            <p className="mt-6 text-xl font-semibold" data-id="element-71" data-mp="cnduko438718">Tú decides qué significa para ti.</p>
            <p className="mt-2 text-lg text-ink/75" data-id="element-72" data-mp="cl01gksyx4wb">Yo voy a enseñarte el sistema que utilicé para acercarme a la mía.</p>
          </div>
        </div>
      </div>
    </section>;
}